import React from "react";
import { SvgIcon } from "@mui/material";
import styles from "../../icons/iconStyles";

const ArrowLeftIcon = ({ color, className, ...props }: any) => {
  return (
    <SvgIcon {...props}>
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M23.3335 14.3202C23.3335 14.7632 23.0043 15.1293 22.5772 15.1872L22.4585 15.1952L4.95849 15.1952C4.47525 15.1952 4.08349 14.8034 4.08349 14.3202C4.08349 13.8772 4.41267 13.5111 4.83976 13.4532L4.95849 13.4452L22.4585 13.4452C22.9417 13.4452 23.3335 13.8369 23.3335 14.3202Z"
          fill="#212121"
        />
        <path
          d="M12.6335 20.7285C12.9759 21.0695 12.9771 21.6235 12.6362 21.9659C12.3262 22.2772 11.8401 22.3065 11.497 22.0531L11.3987 21.9686L4.34039 14.9406C4.02815 14.6297 3.99975 14.1419 4.25519 13.7988L4.34034 13.7006L11.3987 6.67138C11.7411 6.33038 12.2951 6.33153 12.6361 6.67395C12.9461 6.98523 12.9733 7.4714 12.7185 7.81342L12.6335 7.91138L6.19818 14.3209L12.6335 20.7285Z"
          fill="#212121"
        />
      </svg>
    </SvgIcon>
  );
};

export default ArrowLeftIcon;